import {NgModule} from '@angular/core';
import {LifeislifeFooterComponent} from './lifeislife-footer.component';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    LifeislifeFooterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LifeislifeFooterComponent,
  ],
})
export class LifeislifeFooterModule {
}
